(function () {
  function postForm(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var data = new FormData(form);
    return fetch(action, {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' }
    }).catch(function () {});
  }

  function init(root) {
    if (!root || root.dataset.mtContributeReady === 'true') return;
    root.dataset.mtContributeReady = 'true';

    var modal = root.querySelector('[data-mt-contribute-modal]');
    var openBtn = root.querySelector('[data-mt-contribute-open]');
    var closeBtn = root.querySelector('[data-mt-contribute-close]');
    var form = root.querySelector('.mt-contribute__form');
    var success = root.querySelector('[data-mt-contribute-success]');
    var focusField = root.querySelector('[data-mt-contribute-focus]');

    function open() {
      if (!modal) return;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (focusField) focusField.focus();
    }

    function close() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) close();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) return;
        event.preventDefault();
        form.classList.add('is-done');
        if (success) success.classList.add('is-visible');
        postForm(form);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-mt-contribute]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mt-contribute]');
    if (root) {
      root.dataset.mtContributeReady = 'false';
      init(root);
    }
  });
})();
